import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tgx-web-site-public-v3-sign-up-activate-account',
  templateUrl: './v3-sign-up-activate-account.component.html',
  styleUrls: ['./v3-sign-up-activate-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class V3SignUpActivateAccountComponent {
  @Input() protected userEmail = '';
}
